import { z } from 'zod'
import { wireDateSchema } from '../../primitives/wireDate'

const workspaceSchema = z.object({
  uuid: z.string(),
  displayName: z.string().optional(),
})

const orgSchema = z.object({
  name: z.string(),
  displayName: z.string().optional(),
  backofficeUrl: z.string().optional(),
  profileImage: z.string().optional(),
  allowedActions: z.array(z.string()).default(['*']),
  adminAccess: z.boolean().default(false),
  isWorkspaceAdminInOrg: z.boolean().default(false),
})

const orgConfigSchema = z.object({
  uuid: z.string(),
  displayName: z.string().optional(),
  profileImage: z.string().optional(),
  workspaces: z.array(workspaceSchema).default([]),
})

export const myProfileSchema = z.object({
  uuid: z.string(),
  email: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  username: z.string().optional(),
  agentLastLogin: wireDateSchema.optional(),
  emrId: z.string().optional(),
  discipline: z.string().optional(),
  org: orgSchema,
  workspaces: z.array(workspaceSchema).default([]),
  orgs: z.array(orgConfigSchema).default([]),
  isBeta: z.boolean(),
  countRtmTime: z.boolean(),
  intercomIdentity: z.string(),
  intercomIdentityVerificationWebLegacy: z.string().optional(),
})

export type MyProfile = z.infer<typeof myProfileSchema>
export type MyProfileWorkspace = z.infer<typeof workspaceSchema>
export type MyProfileOrg = z.infer<typeof orgSchema>

export const viewerIdentityOf = ({ uuid }: MyProfile): ViewerIdentity => ({ uuid })
export type ViewerIdentity = Pick<MyProfile, 'uuid'>

export const myProfilePath = (): string => '/config/my_profile'
